const actions = {
  AUTO_BILLING_PARTNER_LIST_BEGIN: "AUTO_BILLING_PARTNER_LIST_BEGIN",
  AUTO_BILLING_PARTNER_LIST_SUCCESS: "AUTO_BILLING_PARTNER_LIST_SUCCESS",
  AUTO_BILLING_PARTNER_LIST_ERR: "AUTO_BILLING_PARTNER_LIST_ERR",
  AUTO_BILLING_PARTNER_LIST_RESET: "AUTO_BILLING_PARTNER_LIST_RESET",

  AUTO_BILLING_REFERENCE_BEGIN: "AUTO_BILLING_REFERENCE_BEGIN",
  AUTO_BILLING_REFERENCE_SUCCESS: "AUTO_BILLING_REFERENCE_SUCCESS",
  AUTO_BILLING_REFERENCE_ERR: "AUTO_BILLING_REFERENCE_ERR",
  AUTO_BILLING_REFERENCE_RESET: "AUTO_BILLING_REFERENCE_RESET",

  AUTO_BILLING_PAYMENT_MODE_BEGIN: "AUTO_BILLING_PAYMENT_MODE_BEGIN",
  AUTO_BILLING_PAYMENT_MODE_SUCCESS: "AUTO_BILLING_PAYMENT_MODE_SUCCESS",
  AUTO_BILLING_PAYMENT_MODE_ERR: "AUTO_BILLING_PAYMENT_MODE_ERR",
  AUTO_BILLING_PAYMENT_MODE_RESET: "AUTO_BILLING_PAYMENT_MODE_RESET",

  AUTO_BILLING_SUBMIT_BEGIN: "AUTO_BILLING_SUBMIT_BEGIN",
  AUTO_BILLING_SUBMIT_SUCCESS: "AUTO_BILLING_SUBMIT_SUCCESS",
  AUTO_BILLING_SUBMIT_ERR: "AUTO_BILLING_SUBMIT_ERR",
  AUTO_BILLING_SUBMIT_RESET: "AUTO_BILLING_SUBMIT_RESET",

  AUTO_BILLING_MANUAL_BEGIN: "AUTO_BILLING_MANUAL_BEGIN",
  AUTO_BILLING_MANUAL_SUCCESS: "AUTO_BILLING_MANUAL_SUCCESS",
  AUTO_BILLING_MANUAL_ERR: "AUTO_BILLING_MANUAL_ERR",
  AUTO_BILLING_MANUAL_RESET: "AUTO_BILLING_MANUAL_RESET",

  AUTO_BILLING_HISTORY_BEGIN: "AUTO_BILLING_HISTORY_BEGIN",
  AUTO_BILLING_HISTORY_SUCCESS: "AUTO_BILLING_HISTORY_SUCCESS",
  AUTO_BILLING_HISTORY_ERR: "AUTO_BILLING_HISTORY_ERR",
  AUTO_BILLING_HISTORY_RESET: "AUTO_BILLING_HISTORY_RESET",

  getAutoBillingPartnerListBegin: () => ({
    type: actions.AUTO_BILLING_PARTNER_LIST_BEGIN,
  }),

  getAutoBillingPartnerListSuccess: (data) => ({
    type: actions.AUTO_BILLING_PARTNER_LIST_SUCCESS,
    data,
  }),

  getAutoBillingPartnerListErr: (err) => ({
    type: actions.AUTO_BILLING_PARTNER_LIST_ERR,
    err,
  }),

  getAutoBillingPartnerListReset: () => ({
    type: actions.AUTO_BILLING_PARTNER_LIST_RESET,
  }),

  getAutoBillingReferenceBegin: () => ({
    type: actions.AUTO_BILLING_REFERENCE_BEGIN,
  }),

  getAutoBillingReferenceSuccess: (data) => ({
    type: actions.AUTO_BILLING_REFERENCE_SUCCESS,
    data,
  }),

  getAutoBillingReferenceErr: (err) => ({
    type: actions.AUTO_BILLING_REFERENCE_ERR,
    err,
  }),

  getAutoBillingReferenceReset: () => ({
    type: actions.AUTO_BILLING_REFERENCE_RESET,
  }),

  getAutoBillingPaymentModeBegin: () => ({
    type: actions.AUTO_BILLING_PAYMENT_MODE_BEGIN,
  }),

  getAutoBillingPaymentModeSuccess: (data) => ({
    type: actions.AUTO_BILLING_PAYMENT_MODE_SUCCESS,
    data,
  }),

  getAutoBillingPaymentModeErr: (err) => ({
    type: actions.AUTO_BILLING_PAYMENT_MODE_ERR,
    err,
  }),

  getAutoBillingPaymentModeReset: () => ({
    type: actions.AUTO_BILLING_PAYMENT_MODE_RESET,
  }),

  submitAutoBillingBegin: () => ({
    type: actions.AUTO_BILLING_SUBMIT_BEGIN,
  }),

  submitAutoBillingSuccess: (data) => ({
    type: actions.AUTO_BILLING_SUBMIT_SUCCESS,
    data,
  }),

  submitAutoBillingErr: (err) => ({
    type: actions.AUTO_BILLING_SUBMIT_ERR,
    err,
  }),

  submitAutoBillingReset: () => ({
    type: actions.AUTO_BILLING_SUBMIT_RESET,
  }),

  manualAutoBillingBegin: () => ({
    type: actions.AUTO_BILLING_MANUAL_BEGIN,
  }),

  manualAutoBillingSuccess: (data) => ({
    type: actions.AUTO_BILLING_MANUAL_SUCCESS,
    data,
  }),

  manualAutoBillingErr: (err) => ({
    type: actions.AUTO_BILLING_MANUAL_ERR,
    err,
  }),

  manualAutoBillingReset: () => ({
    type: actions.AUTO_BILLING_MANUAL_RESET,
  }),

  getAutoBillingHistoryBegin: () => ({
    type: actions.AUTO_BILLING_HISTORY_BEGIN,
  }),

  getAutoBillingHistorySuccess: (data) => ({
    type: actions.AUTO_BILLING_HISTORY_SUCCESS,
    data,
  }),

  getAutoBillingHistoryErr: (err) => ({
    type: actions.AUTO_BILLING_HISTORY_ERR,
    err,
  }),

  getAutoBillingHistoryReset: () => ({
    type: actions.AUTO_BILLING_HISTORY_RESET,
  }),
};

export default actions;
